module.exports = __webpack_public_path__ + "static/media/ic-chair.68cce4f4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-chair.svg
// module id = 609
// module chunks = 14